import { lazy, ComponentType } from "react";

const RELOAD_KEY = "chunk-reload-at";

/**
 * React.lazy wrapper that recovers from stale chunk errors after a redeploy.
 * On "Failed to fetch dynamically imported module", reloads the page once
 * (guarded by sessionStorage to avoid reload loops).
 */
export function lazyWithRetry<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>
) {
  return lazy(async () => {
    try {
      const mod = await factory();
      sessionStorage.removeItem(RELOAD_KEY);
      return mod;
    } catch (err) {
      const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
      if (Date.now() - last > 10000) {
        sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
        window.location.reload();
        return new Promise<{ default: T }>(() => {});
      }
      throw err;
    }
  });
}
